/*
 * Copyright (c) 2024 metromorph softworks GmbH
 *
 * All rights reserved
 */

import * as React from "react";

import Component from "./component";

import { 
    useAppState, 
    useAppDispatch,
    clearMessage,
} from "@ef/feature-app";

export default function AppMessage() {
    const { message } = useAppState();
    const dispatch = useAppDispatch();

    if (message) {
        return <Component message={message} onClose={() => dispatch(clearMessage())} />;
    } else {
        return null;
    }
}
